<template>
  <div>
    <div v-if="!model.edit.$model">
      <div v-html="model.recipientHTML.$model" />

      <button class="btn btn-primary" @click="editRecipient(true)">Edytuj</button>
    </div>

    <div v-else>
      <jst-picker :model="jstModel" />

      <w-select class="mt-2" :values="RecipientPositionList" :model="model.position" />

      <person class="mt-2" title="Adresat" :model="model.tenderer" />

      <w-radio-list class="mt-2" :values="recipientIdentifierValues" :model="model.recipientIdentifier" />

      <w-input class="mt-2" :model="model.tenderer.pesel" />

      <w-input class="mt-2" :model="model.tenderer.nip" />

      <button class="btn btn-primary mt-2" @click="editRecipient(false)">Podgląd</button>
    </div>
  </div>
</template>

<script>
import { components } from '@witkac/bootstrap4-components';

import Person from './Person';
import JstPicker from '@/components/formComponents/JstPicker';
import { RecipientPositionList } from '@/enums/recipientPosition.enum';

// @vuese
// Formularz adresata
// @group ActionData
export default {
  components: { ...components, Person, JstPicker },
  props: {
    // schema
    model: { type: Object, required: true },
    // schema JST
    jstModel: { type: Object, required: true }
  },
  data() {
    return {
      RecipientPositionList,
      recipientIdentifierValues: [
        { text: 'nip', value: 'nip' },
        { text: 'pesel', value: 'pesel' }
      ]
    };
  },
  methods: {
    // @vuese
    // Edytuj adresata
    editRecipient(val) {
      this.model.edit.$setData(val);
    }
  }
};
</script>
